import { AxiosResponse } from 'axios';
import { ApiClientWithResponse } from '@/lib/api-client';
import { downloadBlob, getFileNameFromDisposition } from '@/lib/download-util';

function downloadBlobFromEndpoint(
    endpoint: string,
    fallbackFileName: string,
): Promise<void> {
    return ApiClientWithResponse.get<Blob, AxiosResponse<Blob>>(endpoint, {
        responseType: 'blob',
    }).then((response: AxiosResponse<Blob>) => {
        const fileName =
            getFileNameFromDisposition(
                response.headers['content-disposition'],
            ) ?? fallbackFileName;

        downloadBlob(response.data, fileName);
    });
}

export default downloadBlobFromEndpoint;
